// extracted by mini-css-extract-plugin
export default {"title":"dashboard_title__zItjM","cards":"dashboard_cards__6lZYO","actuators":"dashboard_actuators__qtzh6","container":"dashboard_container__OFkHl","image":"dashboard_image__gtn8J"};